export default __webpack_public_path__ + "static/media/shank.088fda94.jpg";